"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styles = require("@qc-modules/styles");

var _propTypes = require("prop-types");

var _styledSystem = require("styled-system");

var _utils = require("../../utils");

var _excluded = ["fieldId", "handleBlur", "handleChange", "handleFocus", "hasLabel", "showValue", "value"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var BasicTextarea = _styledComponents["default"].textarea.withConfig({
  displayName: "textarea__BasicTextarea",
  componentId: "sc-ics8m1-0"
})(["background:transparent;border:none;font-family:inherit;outline:none;transform-origin:0 0;resize:vertical;", ";transform:", ";", ";&::-ms-clear{display:none;}&::placeholder{color:", ";}"], (0, _styles.transitionEase)("0.3s", ["transform"]), function (_ref) {
  var showLabel = _ref.showLabel;
  return "translate3d(0, " + (showLabel ? "5px" : "0") + ", 0)";
}, (0, _styledSystem.compose)(_styledSystem.color, _styledSystem.opacity, _styledSystem.space, _styledSystem.typography, _styledSystem.width), function (props) {
  return (0, _styles.colors)("placeholder", props);
});

var Textarea = function Textarea(_ref2) {
  var fieldId = _ref2.fieldId,
      handleBlur = _ref2.handleBlur,
      handleChange = _ref2.handleChange,
      handleFocus = _ref2.handleFocus,
      hasLabel = _ref2.hasLabel,
      showValue = _ref2.showValue,
      value = _ref2.value,
      props = _objectWithoutPropertiesLoose(_ref2, _excluded);

  return /*#__PURE__*/_react["default"].createElement(BasicTextarea, _extends({
    id: fieldId
  }, _utils.defaultFontSize, _utils.defaultSpacing, {
    color: "text",
    fontWeight: 1,
    onBlur: handleBlur,
    onChange: handleChange,
    onFocus: handleFocus,
    opacity: !hasLabel || showValue ? 1 : 0,
    showLabel: showValue && hasLabel,
    value: value,
    width: 1
  }, props));
};

Textarea.propTypes = {
  /** String for input field id */
  fieldId: _propTypes.string,

  /** onBlur event handler - used to process the event */
  handleBlur: _propTypes.func,

  /** onChange event handler - used to process the event */
  handleChange: _propTypes.func,

  /** onFocus event handler - used to process the event */
  handleFocus: _propTypes.func,

  /** A boolean to check whether the input field has a label */
  hasLabel: _propTypes.bool,

  /** Pattern string to handle validation */
  pattern: _propTypes.string,

  /** A boolean to represent whether the input field should be validated */
  required: _propTypes.bool,

  /** A boolean to represent whether the value should be shown */
  showValue: _propTypes.bool,

  /** Value of form field, either string or number */
  value: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number])
};
Textarea.displayName = "Modules.Textarea)";
var _default = Textarea;
exports["default"] = _default;